'use strict';

/**
 * @classname FooterCategory
 * @classdesc フッターカテゴリー
 */
export default class FooterCategory {
	/**
	 * @constructor
	 * @param {jQuery} $e - #footer .block--category-wrap
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this.adjustCategory();
		$(window).on('resize', () => this.adjustCategory());
	};


	/**
	 * フッター調整
	 *
	 * @memberof FooterCategory
	 * @return undefined
	 */
	adjustCategory() {
		console.log(`${this.constructor.name}.adjustCategory`);
		const $footerCategory = $('.block--footer-accordion');
		if($('body').width() >= 992) {
			let categoryNum = this._$e.children('.block--footer-accordion').length;
			if(categoryNum >= 4) {
				categoryNum = 4;
				$footerCategory.css('width', `calc((100% - 120px) / ${categoryNum})`);
			}else{
				$footerCategory.css('width', `calc((100% - 120px) / ${categoryNum})`).css('margin-right', '0');
				$('.block--category-wrap').css('justify-content', 'space-between');
			}
		}else{
			$footerCategory.removeAttr('style');
		}
	};
};
